/**
 * Testi italiani della scheda «Attività» di un set (ADR 0017).
 */

/** Testi dell'attività degli agenti. */
export const activity = {
  /** Titolo della scheda, per gli assistivi. */
  title: 'Agenti e subagenti al lavoro',
  /** Nessuna attività. */
  empty: "Ancora nessuna attività. Quando l’Institore lavora, qui vedi ogni agente e subagente all'opera.",
  /** Titolo del gruppo di una richiesta. */
  request: 'Richiesta delle {{time}}',
  /** Richiesta con soli allegati. */
  requestFiles: 'Solo allegati',
  /** Nome dell'agente principale se non è noto. */
  mainFallback: 'Institore',
  /** Etichetta dei subagenti. */
  subagent: 'Subagente',
  /** Nome accessibile del percorso nel registro. */
  path: 'Percorso fra gli agenti',
  /** Titolo dei subagenti avviati da un attore. */
  childrenTitle: 'Subagenti avviati',
  /** Subagenti avviati da un attore, sulla scheda. */
  children_one: '{{count}} subagente',
  /** Subagenti avviati da un attore, sulla scheda. */
  children_other: '{{count}} subagenti',
  /** Nome del ruolo di un agente (ADR 0018 §3). */
  role: {
    relay: 'Institore',
    orchestrator: 'Orchestratore',
    frontend: 'Interfaccia',
    backend: 'Backend',
    responsive: 'Controllo responsive',
    security: 'Controllo sicurezza',
    test: 'Test',
    docs: 'Documentazione',
    devops: 'Rilascio e infrastruttura',
    review: 'Revisione',
    explorer: 'Esplorazione del codice',
    planner: 'Piano',
    build: 'Correzione della build',
    agent: 'Subagente',
  },
  /** Nome accessibile della scheda di un agente. */
  openLog: 'Apri il registro di {{label}}',
  /** Titolo del registro. */
  logTitle: 'Registro delle azioni',
  /** Registro vuoto. */
  logEmpty: 'Nessuna azione registrata.',
  /** Origine di un subagente. */
  startedBy: 'Avviato da {{label}}',
  /** Attore senza ancora azioni. */
  waiting: 'In attesa della prima azione…',
  /** Azioni di un attore. */
  actions_one: '{{count}} azione',
  /** Azioni di un attore. */
  actions_other: '{{count}} azioni',
  /** Stato di un attore. */
  status: {
    /** In coda. */
    queued: 'In coda',
    /** Al lavoro. */
    running: 'Al lavoro',
    /** Concluso. */
    done: 'Ha finito',
    /** Fallito. */
    failed: 'Non riuscito',
    /** Annullato. */
    cancelled: 'Annullato',
  },
  /** Tipo di un'azione. */
  kind: {
    read: 'Lettura',
    edit: 'Modifica',
    write: 'Nuovo file',
    run: 'Esecuzione',
    search: 'Ricerca',
    web: 'Web',
    subagent: 'Subagente',
    skill: 'Skill',
    plan: 'Piano',
    mcp: 'Strumento',
    text: 'Messaggio',
    finished: 'Fine',
    failed: 'Errore',
    error: 'Errore',
    status: 'Stato',
    other: 'Azione',
  },
  /** Frase di un'azione con il suo oggetto. */
  sentence: {
    read: 'Legge {{text}}',
    edit: 'Modifica {{text}}',
    write: 'Scrive {{text}}',
    run: '{{text}}',
    search: 'Cerca «{{text}}»',
    web: 'Consulta {{text}}',
    subagent: 'Affida a un subagente: {{text}}',
    skill: 'Usa la skill {{text}}',
    plan: '{{text}}',
    mcp: 'Usa {{text}}',
    text: '{{text}}',
    finished: 'Ha consegnato il risultato',
    failed: 'Si è fermato con un errore',
    error: '{{text}}',
    status: '{{text}}',
    other: '{{text}}',
  },
  /** Frase di un'azione senza oggetto. */
  sentenceEmpty: {
    read: 'Legge un file',
    edit: 'Modifica un file',
    write: 'Scrive un file',
    run: 'Esegue un comando',
    search: 'Cerca nel progetto',
    web: 'Consulta il web',
    subagent: 'Avvia un subagente',
    skill: 'Usa una skill',
    plan: 'Aggiorna il piano',
    mcp: 'Usa uno strumento',
    text: 'Scrive un messaggio',
    finished: 'Ha consegnato il risultato',
    failed: 'Si è fermato con un errore',
    error: 'Errore',
    status: 'Stato aggiornato',
    other: 'Usa uno strumento',
  },
};
